export default __webpack_public_path__ + "static/media/2DShape_01.a141677b.png";